import { forwardRef } from 'react';
import { Select, MenuItem, Checkbox, Box } from '@mui/material';
import SendoutStatusChip from '@components/sendout/SendoutStatusChip';

const SendoutStatusSelect = forwardRef(({ emptyLabel, value, ...params }, ref) => {

    const options = [
        'InProgress',
        'Paused',
        'PausedMissingCredits',
        'Planned',
        'Completed',
        'Canceled'
    ];
    return (
        params.multiple ? (
            <Select ref={ref} value={value} {...params} renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                        <SendoutStatusChip status={value} key={value} tooltip={false} />
                    ))}
                </Box>
            )}>
                {options.map((status) => (
                    <MenuItem key={status} value={status}>
                        <Checkbox checked={value && value.indexOf(status) > -1} />
                        <SendoutStatusChip status={status} key={status} tooltip={false} />
                    </MenuItem>
                ))}
            </Select>
        ) : (
            <Select ref={ref} value={value} {...params}>
                {emptyLabel && <MenuItem value="">{emptyLabel}</MenuItem>}
                {options.map((status) => (
                    <MenuItem key={status} value={status}>
                        <SendoutStatusChip status={status} key={status} tooltip={false} />
                    </MenuItem>
                ))}
            </Select>
        )
    );
});

export default SendoutStatusSelect;